import { render, staticRenderFns } from "./CreateCampaign.vue?vue&type=template&id=625a8015&scoped=true&"
import script from "./CreateCampaign.vue?vue&type=script&lang=js&"
export * from "./CreateCampaign.vue?vue&type=script&lang=js&"
import style0 from "./CreateCampaign.vue?vue&type=style&index=0&id=625a8015&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625a8015",
  null
  
)

export default component.exports